/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 08/04/2022.
 */
import InputNumber from 'antd/lib/input-number'
import { useEffect } from 'react'

export const FormNumber = ({ data, formHook }) => {
  const { register, setValue } = formHook

  useEffect(() => {
    register(data.id)

    if (data.value) {
      setValue(data.id, data.value)
    }
  }, [register, setValue, data.id, data.value])

  const onChange = (value: number) => {
    console.log(' FormNumber > value = ', value)
    setValue(data.id, value)
  }

  return (
    <div className="mt-1 ">
      <p>{data.label}</p>
      <InputNumber
        className="w-100"
        min={data.min !== null ? data.min : 1}
        max={data.max !== null ? data.max : 10}
        defaultValue={data.value !== null ? data.value : 5}
        onChange={onChange}
      />
    </div>
  )
}
